import React from 'react';
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function FailedImport() {
    const {t} = usePolTranslation();

    return (
        <AdminCard title={t('import_failed')}>
            <p>{t('error_import')}</p>
        </AdminCard>
    )
}
